import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
// services
import { MasterService } from '../../../../services/master.service'
import { MessageService } from '../../../../services/message.service';
import * as languageLibrary from '../../../../services/language'
import { SEARCH_DEBOUNCE_MILLIS } from 'src/app/constants/list';
import { Subscription } from 'rxjs';
@Component({
    selector: 'register-form',
    templateUrl: './register-form.component.html',
    styleUrls: ['./register-form.component.scss'],
    standalone: false
})
export class RegisterFormComponent implements OnInit, OnDestroy {
    protected language: any = localStorage.getItem('language') ? localStorage.getItem('language') : 'EN'
    // set all words
    protected words = languageLibrary.language
    // Variables
    
    // define if password input is type text or password
    protected typePassword: string = 'password'
    
    // define if the email is already user
    protected emailExist: boolean = false
    
    // display de loading state
    protected loading: boolean = false
    
    // check accept Terms and Conditions
    protected acceptTerms = false
    
    // corporates user list
    protected userCorporateList = []
    
    // list of unacceptable URLs
    protected unacceptableURLList = ["www"]
    
    // have Password
    protected passwordSet: boolean = false
    
    // 
    protected userId = ''
    
    // 
    protected isWww: boolean = false
    
    // create new corporate variable
    protected newCorporate: boolean = false

    // A debounce timer for search events. Used to wait for 
    // the user to stop typing before we fetch.
    private watcher: ReturnType<typeof setTimeout> = null

    private subscriptions: Subscription[] = []
    
    // Group of inputs
    protected information = new FormGroup({
        email: new FormControl<string | null>(null, [Validators.required, Validators.email, Validators.minLength(5), Validators.maxLength(255), Validators.pattern(/^[a-z0-9\-_\.]+@[a-z0-9\-_\.]+\.[a-z]{2,4}$/)]),
        firstName: new FormControl<string | null>(null, [Validators.required, Validators.maxLength(50), Validators.minLength(1), Validators.pattern('[A-Za-zÑñÁáÉéÍíÓóÚú ]{1,50}')]),
        lastName: new FormControl<string | null>(null, [Validators.required, Validators.maxLength(50), Validators.minLength(1), Validators.pattern('[A-Za-zÑñÁáÉéÍíÓóÚú _-]{1,50}')]),
        password: new FormControl<string | null>(null, [Validators.required, Validators.pattern(/^(?=.*[a-zA-Z])(?=.*\d)(?=.*[!@#\$%\^&\?¿¡\*\(\)_\+\.])[A-Za-z\d][A-Za-z\d!@#\$%\^&\?¿¡\*\(\)_\+\.]{11,255}$/)]),
        companyName: new FormControl<string | null>(null, [Validators.required, Validators.maxLength(150), Validators.minLength(3)]),
        corporateURL: new FormControl<string | null>(null, [Validators.required, Validators.maxLength(150), Validators.minLength(3), Validators.pattern('[A-Za-z0-9_-]{3,150}')]),
        phone: new FormControl<string | null>(null, [Validators.required, Validators.pattern('[0-9-\(\)\+]{3,20}')]),
        dealerNumber: new FormControl<string | null>(null, [Validators.required, Validators.maxLength(150), Validators.minLength(3)]),
        position: new FormControl<string | null>(null, [Validators.required]),
        acceptTerms: new FormControl<boolean>(false, [Validators.required, Validators.pattern("true")]),
    })

    /** Indicates the coproation already exists. */
    public corporateExists: boolean;

    // get information of inputs
    get email() { return this.information.get('email') }
    get firstName() { return this.information.get('firstName') }
    get lastName() { return this.information.get('lastName') }
    get password() { return this.information.get('password') }
    get corporateURL() { return this.information.get('corporateURL') }
    get companyName() { return this.information.get('companyName') }
    get phone() { return this.information.get('phone') }
    get dealerNumber() { return this.information.get('dealerNumber') }

    constructor(private master: MasterService, private ms: MessageService, private router: Router) { }

ngOnInit() {

        this.subscriptions.push(
            this.information.get('email').valueChanges.subscribe(email => {
                if (this.watcher) {
                    clearTimeout(this.watcher)
                    this.watcher = null
                }

                if (this.email.invalid) {
                    return
                }
        
                this.watcher = setTimeout(() => {           
                    this.findUser()
                }, SEARCH_DEBOUNCE_MILLIS)
            })
        )
    }

    ngOnDestroy() {
        for (const sub of this.subscriptions) {
            sub.unsubscribe()
        }
        if (this.watcher) {
            clearTimeout(this.watcher)
        }
    }

    // change the input type, passsword or text
    protected changeTypePassword = (): void => {
        if (this.typePassword == 'text') {
            this.typePassword = 'password'
        } else {
            this.typePassword = 'text'
        }
    }

    protected preValidateCorporateURL = () => {
        this.information.controls['corporateURL'].setErrors(null);
        let corpURL = this.information.value['corporateURL'] ? this.information.value['corporateURL'].toLowerCase().toLowerCase() : null
        if (!corpURL) {
            return
        }
        if (this.userCorporateList.find(res => res.corporateURL.toLowerCase() === corpURL + '.autoactioncloud.com')) {
            this.information.controls['corporateURL'].setErrors({ 'duplicateCorp': 'This is a duplicate corporation.' });
            return
        }
        if (this.unacceptableURLList.find(res => res === corpURL)) {
            this.information.controls['corporateURL'].setErrors({ 'unacceptableURL': 'Please enter a valid Corporate URL.' });
        }
        this.information.get('corporateURL').setValue(corpURL)
    }

    protected setCorporateURL() {
        this.information.get('corporateURL').setValue(this.information.get('companyName').value.replaceAll(/\s+/gi, '').replaceAll(/[^A-Za-z]/gi, ''))
        this.preValidateCorporateURL()
    }

    protected registerCorporation() {
        this.preValidateCorporateURL()
        if (this.information.invalid) {
            return
        }

        this.master.post(`corporations`, { information: this.information.value }, res => {
            if (!res) {
                this.ms.sendMessage("alert", { type: "danger", text: this.words[this.language]['apiNoResponse'] })
                return
            }

            if (res.status === 409) {
                this.ms.sendMessage("alert", { type: "danger", text: res.data.error })

                this.corporateExists = true
                this.information.controls['corporateURL'].setErrors({ 'duplicateCorp': res.error });
                return
            }

            if (res.status !== 200) {
                this.ms.sendMessage("alert", { type: "danger", text: res.data.error })
                return
            }

            this.router.navigate([`email/${this.information.get('email').value}`])
        })
    }

    protected findUser() {
        if (this.email.invalid) {
            return
        }

        this.passwordSet = false
        this.userCorporateList = []

        this.master.get(`users/lookup?email=${encodeURIComponent(this.email.value)}`, res => {
            if (!res) {
                this.ms.sendMessage("alert", { type: "danger", text: this.words[this.language]['apiNoResponse'] })
                return
            }

            if (res.status === 404) { // Not found
                return
            }

            if (res.status !== 200) {
                this.ms.sendMessage("alert", { type: "danger", text: res.data.error })
                return
            }

            if (!res.data.userAndCorp || !res.data) {
                this.showNewUserForm(true)
                return
            }

            this.userCorporateList = res.data.userAndCorp.corporates
            this.userId = res.data.userAndCorp.userId
            this.passwordSet = res.data.userAndCorp.passwordSet
            
            if (this.passwordSet) {
                this.information.get('password').setValidators(null)
                this.information.get('password').updateValueAndValidity()
            } 
            else {
                this.information.get('password').setValidators([Validators.required, Validators.pattern(/^(?=.*[a-zA-Z])(?=.*\d)(?=.*[!@#$%^&?¿¡*()_+])[A-Za-z\d][A-Za-z\d!@#$%^&?¿¡*()_+]{7,39}$/)])
                this.information.get('password').updateValueAndValidity()
            }

            this.preValidateCorporateURL()
            this.showNewUserForm(false)
        })
    }

    protected showNewUserForm(show) {
        this.newCorporate = show
        this.preValidateCorporateURL()
    }

    protected domain = (): string => {
        const hostname = window.location.hostname
        if (hostname.includes('.dev.autoactioncloud.com')) {
            return '.dev.autoactioncloud.com'
        }
        if (hostname.includes('.uat.autoactioncloud.com')) {
            return '.uat.autoactioncloud.com'
        }
        return '.autoactioncloud.com'
    }
}
